import { privateAxios } from "../axiosInstances";

export const downloadEventTickets = async (
  eventId: string,
  ticketTypeId: string,
  eventName: string,
  saveAs: (file: File) => void
) => {
  privateAxios
    .get<string>(
      `/events/${eventId}/tickets/download-tickets/${ticketTypeId}`,
      {
        responseType: "blob",
      }
    )
    .then((blob) => {
      const file = new File([blob.data], `Billets - ${eventName}.pdf`, {
        type: "application/pdf",
      });

      saveAs(file);
    });
};

export const downloadEventBadges = async (
  eventId: string,
  badgeTypeId: string,
  eventName: string,
  saveAs: (file: File) => void
) => {
  privateAxios
    .get<string>(`/events/${eventId}/badges/download-badges/${badgeTypeId}`, {
      responseType: "blob",
    })
    .then((blob) => {
      const file = new File([blob.data], `Badges - ${eventName}.pdf`, {
        type: "application/pdf",
      });

      saveAs(file);
    });
};
